﻿cb.define([], function () {
  var ST_st_storenotice_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {

      let params = viewmodel.getParams();
      let mode = params && params.mode || env.VOUCHER_STATE_BROWSE;
      let gridModel = viewmodel.getGridModel();
      //向后台传递行号
      gridModel.setState('orderField', 'rowno');
      if (mode === "add") {
        viewmodel.get("btnMoveprev").setVisible(false);
        viewmodel.get("btnMovenext").setVisible(false);
      }
    }
  }
  try {
    module.exports = ST_st_storenotice_VM_Extend;
  } catch (error) {

  }
  return ST_st_storenotice_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storenotice_VM.Extend.js